import React from 'react';

import { ModalWrapper } from '@/components/wrappers';

import { useSpendLimitsModalActions } from './hooks/useSpendLimitsModalActions';
import { SpendLimitsForm } from './SpendLimitsForm';

export const SpendLimitsModal = () => {
  const { modalVisible, handleCancel, handleApply } = useSpendLimitsModalActions();

  return (
    <ModalWrapper
      testId="SpendLimitsModal"
      visible={modalVisible}
      onSetVisible={handleCancel}
      titleBoxStyle={{
        paddingBottom: '16px',
        paddingInline: '12px',
        textAlign: 'center',
      }}
      isClosingByClickOutsideBlocked
    >
      <SpendLimitsForm onCancel={handleCancel} onApply={handleApply} />
    </ModalWrapper>
  );
};
